export default "__VITE_ASSET__Cv8Au0W9__"